import { getSaleObjectStore, hasSalesStore } from "./indexedDbCrud.helper"

let offlineSales = []

const filterCursorByDocument = (filters, cursor) => {
  return cursor?.value.document === filters.customer_document
}

const canAddSaleToList = (filters, cursor) => {
  let canAddSale = true

  if (filters?.customer_document) {
    canAddSale = filterCursorByDocument(filters, cursor)
  }

  return canAddSale && cursor
}

const filterResultByDocument = (result, document) => {
  if (document) {
    return result.filter(sale => sale.document === document)
  }

  return result
}

const handleSetDate = date => {
  return date ? new Date(date).toISOString() : null
}

const getFilterRange = (startDate, endDate) => {
  if (startDate && endDate) return IDBKeyRange.bound(startDate, endDate)

  if (!startDate) return IDBKeyRange.upperBound(endDate)

  if (!endDate) return IDBKeyRange.lowerBound(startDate)
}

const handleCursorSuccess = async (event, db, commit, filters) => {
  const cursor = event.target.result

  if (canAddSaleToList(filters, cursor)) {
    await commit("addOfflineSale", cursor.value)
    cursor.continue()
  }

  if (!cursor) db.close()
}

const getAllSalesSuccess = async (db, commit, requestAll, filters) => {
  let result = filterResultByDocument(
    requestAll.result,
    filters?.customer_document
  )

  await commit("setOfflineSales", result)
  db.close()

  offlineSales = result
}

const handleGetAllSales = async (db, objectStore, filters, commit) => {
  const requestAll = await objectStore.getAll()
  requestAll.onsuccess = async () =>
    await getAllSalesSuccess(db, commit, requestAll, filters)
}

const hasDateFilters = filters => filters?.start_date || filters?.end_date

const handleGetFilteredSaleByDate = async (
  commit,
  filters,
  objectStore,
  db
) => {
  commit("setOfflineSales", [])
  let startDate = handleSetDate(filters?.start_date)
  let endDate = handleSetDate(filters?.end_date)
  let range = getFilterRange(startDate, endDate)

  const index = objectStore.index("by_created_at")

  index.openCursor(range).onsuccess = async event => {
    await handleCursorSuccess(event, db, commit, filters)
  }
}

const handleOfflineSalesList = async (event, commit, filters) => {
  const db = event.target.result
  const objectStore = getSaleObjectStore(event, "readonly", "sales")

  await commit("setOfflineSales", [])

  if (!hasDateFilters(filters)) {
    await handleGetAllSales(db, objectStore, filters, commit)
  } else {
    await handleGetFilteredSaleByDate(commit, filters, objectStore, db)
  }
}

const handleOfflineSalesListIfStoreExists = async (event, commit, filters) => {
  const db = event.target.result
  hasSalesStore(db.objectStoreNames) &&
    (await handleOfflineSalesList(event, commit, filters))
}

export const handleListOfflineSalesSuccess = async (event, commit, filters) => {
  await handleOfflineSalesListIfStoreExists(event, commit, filters)
  return offlineSales
}
